import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import {ResultTime} from '../../models/ResultTimes'
import { fetchData, postData } from '../../services/ApiService';
import {
  closeCircularProgress,
  openCircularProgress,
} from "../uireducers/progress";


// Logic to Get All Templates
export const getAllResultTimes = createAsyncThunk(
  "resultTimeEntity/getAllResultTimes",
  async (data, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      const response = await fetchData("times"); // Specify the type if known
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return response; // Return the fetched data
    } catch (error) {
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error); // Handle the error appropriately
    }
  }
);


// Logic to save template
export const saveResultTime = createAsyncThunk(
  "resultTimeEntity/saveResultTime",
  async (data: ResultTime, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await postData(`times`, data); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error); // Handle the error appropriately
      }
  }
);

const slice = createSlice({
  name: "resultTimeEntity",
  initialState: {
    resultTimes: [] as ResultTime[]
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getAllResultTimes.fulfilled, (state, action) => {
      state.resultTimes = action.payload;
    });
    builder.addCase(saveResultTime.fulfilled, (state, action)=>{
      const updatedState = _.cloneDeep(state.resultTimes);
      updatedState.push(action.payload);
      state.resultTimes = updatedState;
    });
  },
});

//export const { setSelectedGame } = slice.actions;

export default slice.reducer;